import React, { useState } from "react"
import styled from "styled-components"
import { useLocation } from "react-router-dom"

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { Line } from "react-chartjs-2"
import faker from "faker"

const StatisticsScreen = () => {
  const [toggleTab, setToggleTab] = useState(0)

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  )
 

  const location = useLocation()
    console.log(location.hash.replace('%20', " ").substring(1))

  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
  ]
  const countrylabels = [
    "India",
    "Chile",
    "USA",
    "Tokyo",
    "Spain",
    "Germany",
    "Germany",
  ]

  const data = {
    labels,
    datasets: [
      {
        label: "Dataset 1",
        data: labels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Dataset 2",
        data: labels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  }
  const graphdata = {
    labels,
    datasets: [
      {
        label: "sales per user",
        data: countrylabels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "#1F78B4CC",
        backgroundColor: "#1F78B4CC",
      }
    ]
  }
  const userhdata = {
    labels,
    datasets: [
      {
        label: "New User",
        data: countrylabels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "#1F78B4CC",
        backgroundColor: "#1F78B4CC",
      }
    ]
  }
  const noofusers = {
    labels,
    datasets: [
      {
        label: "new connections",
        data: countrylabels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "#21D39E",
        backgroundColor: "#21D39E",
      },
      {
        label: "new registrations",
        data: countrylabels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "#1F78B4",
        backgroundColor: "#1F78B4",
      },
      {
        label: "frequency of visits to the site",
        data: countrylabels.map(() =>
          faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "#A6CEE3",
        backgroundColor: "#A6CEE3",
      }
    ]
  }

  return (
    <>
        <PageTitle>{location.hash.replace('%20', " ").substring(1)}</PageTitle>
      <MainContent>
        <VerticalTabBar>
          <AdminListArr>
            <Tabbtn
              onClick={() => setToggleTab(1)}
              className={toggleTab === 1 ? "active-tab" : ""}
            >
              Numbers
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(2)}
              className={toggleTab === 2 ? "active-tab" : ""}
            >
              Graph
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(3)}
              className={toggleTab === 3 ? "active-tab" : ""}
            >
              Time
            </Tabbtn>
          </AdminListArr>
        </VerticalTabBar>
        <ChartContainer>
          {
            toggleTab === 1 || location.hash.replace('%20', " ").substring(1) === 'Number' ?
            <>
            <ChartCard>
              <Line data={data} />
            </ChartCard>
            <ChartCard>
              <Line data={data} />
            </ChartCard>
            <ChartCard>
              <Line data={data} />
            </ChartCard>
            <ChartCard>
              <Line data={data} />
            </ChartCard>
            </>
            : toggleTab === 2 || location.hash.replace('%20', " ").substring(1) === 'Graph'?
            <>
          <ChartCard>
            <Line data={graphdata} />
          </ChartCard>
          <ChartCard>
            <Line data={noofusers} />
          </ChartCard>
          <ChartCard>
            <Line data={userhdata} />
          </ChartCard>
          <ChartCard>
            <Line data={noofusers} />
          </ChartCard>
          </>
          : toggleTab === 3 || location.hash.replace('%20', " ").substring(1) === 'Time'?
          <>
          <ChartCard>
            <Line data={graphdata} />
          </ChartCard>
          <ChartCard>
            <Line data={graphdata} />
          </ChartCard>
          <ChartCard>
            <Line data={graphdata} />
          </ChartCard>
          <ChartCard>
            <Line data={graphdata} />
          </ChartCard>
          </>
          : null

          }
        </ChartContainer>
      </MainContent>
    </>
  )
}

export default StatisticsScreen

const MainContent = styled.div`
  display: flex;
  height: 90vh;
`
const VerticalTabBar = styled.div`
  display: flex;
  position: sticky;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  width: 20%;
  min-width: 20%;
  max-width: 20%;
  background: ${({theme}) => theme.background};
  /* background: cyan; */

  .active-tab {
    background: #dc1d13;
    transition: 500ms;
    cursor: pointer;
    color: ${({theme}) => theme.text};
  }

  @media (max-width: 768px){
    display: none;
  }
`
const AdminFormWrap = styled.div`
  display: flex;
  width: 100%;
  background: #fff;

  .infotip_label {
    position: absolute;
    bottom: -5rem;
    right: 1.5rem;
  }
`

const AdminListArr = styled.div`
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding-top: 1.5rem;
  width: 100%;
  overflow-y: auto;
`
const Tabbtn = styled.button`
  color: ${({theme}) => theme.text};
  text-decoration: none;
  border: none;
  background: none;
  padding: 0.6rem 0rem;
  transition: 500ms;
  cursor: pointer;
  margin-bottom: 2rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 29px;
  border-radius: 0px 5px 5px 0px;
`
const ChartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 1rem;
  justify-content: space-evenly;
  overflow-y: auto;
  height: 80vh;
`
const ChartCard = styled.div`
  display: flex;
  width:  20rem;
  height: 12rem;
  padding: 1rem;
  background: ${({theme}) => theme.background};
  border-radius: 5px;
  margin: 0.5rem 0rem;
`
const PageTitle = styled.div`
  padding: 1rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  color: ${({theme}) => theme.text};
  display: none;
  @media (max-width: 768px){
    display: block
  }

`
